import {
  ActionType,
  DepartmentListBusinessResponse,
} from "models/userListBusiness/departmentList";

export const getDepartmentsListAction = () => {
  return {
    type: ActionType.DEPARTMENT_LIST_BUSINESS,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DEPARTMENT_LIST_BUSINESS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: DepartmentListBusinessResponse) => {
  return {
    type: ActionType.DEPARTMENT_LIST_BUSINESS_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.DEPARTMENT_LIST_BUSINESS_RESET_DATA,
  };
};
